import {
  GET_SCR_V2_REVERSIBLE_TRANSACTION_LIST,
  REOPEN_SCR_V2_TRANSACTION,
} from "../../../Types";

const initialState = {
  list: {
    items: [],
    totalRecords: 0,
    pageNumber: 1,
    pageSize: 20,
  },
  lastReopenedTransactionId: null,
};

const SCRV2TransactionReversalReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SCR_V2_REVERSIBLE_TRANSACTION_LIST:
      return {
        ...state,
        list: action.payload || initialState.list,
      };
    case REOPEN_SCR_V2_TRANSACTION: {
      const reopenedTransactionId =
        action.payload?.nonVizLinkTransactionId ||
        action.payload?.NonVizLinkTransactionId ||
        null;

      if (!reopenedTransactionId) {
        return {
          ...state,
          lastReopenedTransactionId: null,
        };
      }

      return {
        ...state,
        lastReopenedTransactionId: reopenedTransactionId,
        list: {
          ...state.list,
          items: (state.list.items || []).map((item) =>
            item.transactionId === reopenedTransactionId
              ? {
                  ...item,
                  isReversed: true,
                  canReverse: false,
                  cannotReverseReason: null,
                }
              : item
          ),
        },
      };
    }
    default:
      return state;
  }
};

export default SCRV2TransactionReversalReducer;
